/* @flow */
import React from 'react';
import Glyph from 'components/Glyph.jsx';
import ModalTrigger from 'components/ModalTrigger.jsx';
import LinkBankAccountModal from 'payments/components/LinkBankAccountModal.jsx';
import IdentityVerificationModal from 'payments/components/IdentityVerificationModal.jsx';
import PendingConnectedBankAccountRequestsModalContainer from 'payments/containers/PendingConnectedBankAccountRequestsModalContainer.jsx';
import IdentityAdditionalVerificationModalContainer from 'payments/containers/IdentityAdditionalVerificationModalContainer.jsx';

import './styles/ActivitiesNotification.scss';

class ActivitiesNotification extends React.Component {
  props: {text: string};

  render() {
    const { text, ...rest } = this.props;

    return (
      <div {...rest} className="ActivitiesNotification">
        <div className="ActivitiesNotification-info">
          <Glyph name="explanation-circle" size="large" />
          {text}
        </div>
        <div className="ActivitiesNotification-action">
          <Glyph name="chevron-right" size="xsmall" />
        </div>
      </div>
    );
  }
}

class PaymentAccountVerificationNotification extends React.Component {
  render() {
    return (
      <ModalTrigger modal={<IdentityVerificationModal />}>
        <ActivitiesNotification text="Verify your information" />
      </ModalTrigger>
    );
  }
}

class PendingBankAccountRequestNotification extends React.Component {
  props: {
    number: number,
  };

  render() {
    return (
      <ModalTrigger modal={<PendingConnectedBankAccountRequestsModalContainer />}>
        <ActivitiesNotification text={`${this.props.number} deposit requests`} />
      </ModalTrigger>
    );
  }
}

class PaymentAccountAdditionalVerificationNotification extends React.Component {
  render() {
    return (
      <ModalTrigger modal={<IdentityAdditionalVerificationModalContainer />}>
        <ActivitiesNotification text="Additional identity verification" />
      </ModalTrigger>
    );
  }
}

class AddBankAccountNotification extends React.Component {
  props: {
    onBankAccountAdded: () => void,
  };

  render() {
    return (
      <ModalTrigger modal={<LinkBankAccountModal onBankAccountAdded={this.props.onBankAccountAdded} />}>
        <ActivitiesNotification text="Add a bank account" />
      </ModalTrigger>
    );
  }
}

export {
  PaymentAccountAdditionalVerificationNotification,
  PaymentAccountVerificationNotification,
  PendingBankAccountRequestNotification,
  AddBankAccountNotification,
};



// WEBPACK FOOTER //
// ./src/payments/components/ActivitiesNotification.jsx